import BuildConfig from '$extensionSrc/buildConfig'

import { AUTOMATION_STAGE_STATUSES } from '../genericAutomationStageStatuses'

export const INSTAGRAM_AUTOMATION_STAGE_STATUSES = {
  ...AUTOMATION_STAGE_STATUSES,
  DELETING_YOUR_POSTS: {
    body: 'Please keep this tab open.',
    progress:
      "We'll send you an alert when everything's finished. This might take a little while depending on how many posts you have.",
    title: `${BuildConfig.TENANT_NAME} is deleting your posts...`,
  },
  ARCHIVING_POSTS: {
    body: 'Please keep this tab open.',
    progress:
      "We'll send you an alert when everything's finished. This might take a little while depending on how many posts you have.",
    title: `${BuildConfig.TENANT_NAME} is archiving your posts...`,
  },
}
